import { render, staticRenderFns } from "./SkupPrometEdit.vue?vue&type=template&id=bd34449c&scoped=true&"
import script from "./SkupPrometEdit.vue?vue&type=script&lang=js&"
export * from "./SkupPrometEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd34449c",
  null
  
)

export default component.exports